import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';

import useAppState from 'context/useAppState';

import CustomDropdown from '../dropdown/Dropdown'
import { assignTaskSchema } from 'schema/validation'
import { Modal } from './Modal';
import { HeaderModal } from './Header';
import { Body } from './Body';
import { FooterModal } from './Footer';

import allImgPaths from 'assets/images';
import { updatedMemberList, updatedTaskList } from 'utils/function';


function AssignTaskModal() {

    //id => eventId
    const { id } = useParams();
    const [taskList, setTaskList] = useState<any>([]);
    const [teamMemberList, setTeamMemberList] = useState([])

    const { showAssignModal, fetchTaskListService, fetchMemberListService, setState: setChatBoxState, state } = useAppState('chatBox');
    const { updateTask } = useAppState('taskHook');
    const { getBoardData, setState: setCardWrapperState, selectedCardDetail } = useAppState('cardWrapper');

    const [selectTeamMember, setSelectTeamMember] = useState(null);
    const [selectedTask, setSelectedTask] = useState<any>(null);
    const [inputValue, setInputValue] = useState('');


    useEffect(() => {
        if (showAssignModal && selectedCardDetail) {
            (async () => {
                const payload = {
                    eventId: id,
    
                    // block_id: selectedCardDetail?.block_id,
                    block_id: selectedCardDetail?.columnId || selectedCardDetail?.block_id,
                    card_id: selectedCardDetail?.id
                }
                // fetch list of task of particular block and card
                const tasks = await fetchTaskListService(payload);
                setTaskList(updatedTaskList(tasks));
                setSelectedTask(updatedTaskList(tasks)[0])
            })()
        }
    }, [showAssignModal]);

    useEffect(() => {
        if (taskList.length > 0 && showAssignModal) {
            (async() => {
                // fetch member list
                const teamMembers = await fetchMemberListService(id);
                setTeamMemberList(updatedMemberList(teamMembers));
            })()
        }
    }, [taskList.length > 0])

    const handleChange = (selectedValue: any) => {
        setInputValue(selectedValue?.value || inputValue);
        setSelectTeamMember(selectedValue);
    }

    const handleTaskSelect = (selectedValue: any) => {
        setSelectedTask(selectedValue)
        setValue('assignTask', { value: selectedValue.value, label: selectedValue.label });
    }

    const onCloseModal = () => {
        setChatBoxState({ ...state, showAssignModal: false })
        setSelectTeamMember(null);
    }

    const {
        control,
        handleSubmit,
        getValues,
        setValue,
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            teamEmail: { value: "", label: "" },
            assignTask: { value: "", label: "" }
        },
        resolver: yupResolver(assignTaskSchema),
    });

    //set the  default selected value for task list
    useEffect(() => {
        if (showAssignModal && selectedTask) {
            setValue('assignTask', { value: selectedTask.value, label: selectedTask.label })
        }
    }, [showAssignModal,selectedTask]);

    const onFormSubmit = async (data: any) => {
        const payload = {
            // block_id: selectedCardDetail?.block_id,
            block_id: selectedCardDetail?.columnId || selectedCardDetail?.block_id,
            assigned_to: data.teamEmail.value,
            card_id: selectedCardDetail?.id,
            task_id: data.assignTask.value,
        }
        await updateTask(id, payload)
        await getBoardData(id);
        // setting the card and column data empty
        setCardWrapperState({ cards: [], columns: [] })

        setSelectTeamMember(null);
        setValue('assignTask', { value: "", label: "" })
        setSelectedTask(null);
        setChatBoxState({ ...state, showAssignModal: false });
    }

    return (
        <>
            <Modal className={"modal-wrapper max-w-[400px]"} isShow={showAssignModal}>
                <form onSubmit={handleSubmit(onFormSubmit)}>

                    <HeaderModal title="" isShowHeader={true} className="modal-header pt-6 px-6 pb-5 border-b border-[#EAECF0]">
                        <div className="flex items-center justify-between">
                            <div className='flex justify-center items-center gap-x-4'>
                                <img className=" top-0.5 left-0 object-contain -z-10" src={allImgPaths.featuredIcon} alt="assign task image" />
                                <h2 className="text-lg text-[#101828] font-interSemiBold leading-none">Assign Task</h2>
                            </div>

                            {/* Close Icon */}
                            <img
                                className="modal-close modal-toggle cursor-pointer hover:bg-[#F2F4F7] rounded w-5 p-1 -mt-6"
                                id="modal-toggle"
                                src={allImgPaths.closeIcon}
                                onClick={onCloseModal}
                                alt="close icon"
                            />
                        </div>
                    </HeaderModal>
                    <Body title="" isShowBody={true} className="modal-body px-6 pt-4">
                        <div className="mb-2.5">
                            <p className="text-[15px] text-[#344054] font-interMedium pb-1.5">Team member</p>
                            <div className="modal-select-box fete-settings-modals adjust-height-modals">
                                <CustomDropdown
                                    name="teamEmail"
                                    control={control}
                                    placeholder="Select or enter email address"
                                    selectedValue={selectTeamMember}
                                    isSearchable={true}
                                    onChange={handleChange}
                                    options={teamMemberList}
                                />
                            </div>
                        </div>

                        <div className="mb-6">
                            <p className="text-[15px] text-[#344054] font-interMedium pb-1.5">Apply to task</p>
                            <div className="modal-select-box fete-settings-modals">
                                <CustomDropdown
                                    name="assignTask"
                                    control={control}
                                    placeholder="Select"
                                    // isSearchable={true}
                                    selectedValue={selectedTask}
                                    onChange={handleTaskSelect}
                                    options={taskList}
                                />
                            </div>
                            {/* <p className='text-red-600'>{error}</p> */}
                        </div>
                    </Body>
                    <FooterModal title="" isShowFooter={true} className="modal-footer pt-5 px-6 pb-5 border-t border-[#EAECF0]">
                        <div className="flex items-center gap-x-3 justify-end">
                            <button onClick={onCloseModal} className="text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base hover:bg-[#f2f4f7] flex-1">Cancel</button>
                            <button
                                className={`text-[#fff] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base bg-[#1E0AF5] hover:bg-[#120693] flex-1 ${(!selectedTask || !selectTeamMember) ? 'button-disabled' : ''} `}
                            >
                                Assign Task
                            </button>
                        </div>
                    </FooterModal>
                </form>
            </Modal>
        </>
    )
}

export default AssignTaskModal